export default __webpack_public_path__ + "static/media/beep-01a.40e5c7db.mp3";